import { FirebaseAuthBackend, getFirebaseBackend } from 'helpers/firebase_helper';
import { Media, MediaMetaData } from 'helpers/models/media.model';
import React, { useEffect, useState } from 'react';
import Dropzone from 'react-dropzone';
import { Card, Col, Popover, PopoverBody, Row } from 'reactstrap';
import { UploaderAcceptance } from 'utils/constants';
import Loader from './Loader';
import ImageViewer from './ImageViewer';
import imageUploader from "../../assets/images/image.png"
import uplaoderIcon from "../../assets/images/iIcon.svg"
import MediaCenterUploadModal from 'pages/Ecommerce/EcommerceProducts/MediaCenter/components/MediaCenterUploadModal';
import { toast, ToastContainer } from 'react-toastify';
import { createSelector } from 'reselect';
import { useSelector } from 'react-redux';
import ErrorModal from './ErrorModal';
import pdfImage from "../../assets/images/pdf.png"
import { getS3Upload } from 'helpers/backend_helper';


type UpdateMediaFunction = (media: Media | Media[]) => void;

type MediaUploaderProps = {
    onMediaUpdate: UpdateMediaFunction;
    isMultiple?: boolean; // Optional, default can be set inside the function
    initialMedia?: Media[] | Media; // Optional, default can be set inside the function
    uploaderType?: string; // Optional, default can be set inside the function
    smallUploader?: boolean;
    dataTestingId?: string;
    infoBar?: string;
    title?: string;
    isRequired?: boolean
    threeDotIcon?: boolean
    allowPdf?: boolean;
};

const MediaUploader: React.FC<MediaUploaderProps> = ({
    onMediaUpdate,
    isMultiple = false,
    smallUploader = false,
    initialMedia = [],
    uploaderType = "images",
    dataTestingId = "",
    infoBar = "",
    title = "",
    isRequired = false,
    threeDotIcon = false,
    allowPdf = false,

}) => {
    const [media, setMedia] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const firebaseHelper: FirebaseAuthBackend | null = getFirebaseBackend();
    const maxFiles: number | undefined = isMultiple ? undefined : 1;
    // const acceptance: any = UploaderAcceptance[uploaderType];
    const acceptance: any = allowPdf
    ? {
        'application/pdf': ['.pdf'],
        'image/*': ['.jpeg', '.jpg', '.png', '.gif', '.bmp', '.webp']
      }
    : UploaderAcceptance[uploaderType];

    const [isViewerOpen, setViewerOpen] = useState(false);
    const [currentImage, setCurrentImage] = useState("");
    const [currentDataId, setCurrentDataId] = useState("");
    const [mediaCenterUploadModal, setMediaCenterUploadModal] = useState<boolean>(false);
    const [activePopover, setActivePopover] = useState<string | null>(null);
    const [uploadModalOpen, setUploadModalOpen] = useState(false);

  
    const [errorMessage, setErrorMessage] = useState<string>("");
    const [showModal, setShowModal] = useState({
        isVisible: false,
        color: false,
      });


    const handleDataFromMediaCenter = (mediaArray: any[]) => {
        setMedia(mediaArray);
    };

    const getUploadUrl = async (file: File): Promise<string | null> => {
        try {
            const fileName = encodeURIComponent(file.name);

            const res: any = await getS3Upload(fileName,file.type); // Your API returns { uploadUrl }
            const uploadUrl = res?.data?.uploadUrl;

            if (uploadUrl) {

                const myHeaders = new Headers();
                myHeaders.append("Content-Type", file.type);
                const requestOptions: any = {
                    method: "PUT",
                    headers: myHeaders,
                    body: file,
                    redirect: "follow"
                };
                await fetch(uploadUrl, requestOptions);
            }

            return res.data.fileUrl;
        } catch (err) {
            console.error("S3 upload error", err);
            return null;
        }
    };


    // useEffect(() => {
    //     if (!initialMedia) return;
    //     setMedia((prev) => {
    //         if (prev && prev.length > 0) return prev;
    
    //         if (Array.isArray(initialMedia)) {
    //             return initialMedia;
    //         } else {
    //             return [initialMedia];
    //         }
    //     });
    // }, [initialMedia]);


    useEffect(() => {
        if (!initialMedia) return;
    
        setMedia((prev) => {
            const initialArray = Array.isArray(initialMedia) ? initialMedia : [initialMedia];
    
            // Check if prev is already same as initialArray
            const isSame = JSON.stringify(prev) === JSON.stringify(initialArray);
            if (isSame) return prev;
    
            return initialArray;
        });
    }, [initialMedia]);
    
    

    useEffect(() => {
        if (dataTestingId) {
            setCurrentDataId(dataTestingId)
        }
    }, [dataTestingId]);

    const closeViewer = () => {
        setViewerOpen(false);
    };

    const openViewer = (imageUrl: string) => {
        setCurrentImage(imageUrl);
        setViewerOpen(true);
    };

    const handleAcceptedFiles = async (files: any) => {
        if (!files || files.length === 0) {
            toast.error("Only one image can be uploaded at a time.", {
                autoClose: 1000,
              });
            return;
            // setShowModal(true);
            // console.log("Only one image can be uploaded at a time.")
            // setErrorMessage("Only one image can be uploaded at a time")
            // setTimeout(() => {
            //     setShowModal(false);
            // }, 2000);
            // return;
        }
        setIsLoading(true);
        let uploadedFiles: Media[] = [...media];
        const maxSize = 10 * 1024 * 1024;
        for (let file of files) {
            // if (file.size > maxSize) {
            //     toast.error(`The file ${file.name} is too large. Maximum size is 10MB.`, {
            //         autoClose: 1000, // 1000ms = 1 second
            //     });
            //     continue;
            // }

              if (file.size > maxSize) {
                setShowModal({ isVisible: true, color: false });
                setErrorMessage(`The file ${file.name} is too large. Maximum size is 10 MB.`);
                setTimeout(() => {
                  setShowModal({ isVisible: false, color: false });
                }, 3000);
                continue;
            }
    
            const url = await getUploadUrl(file);
            if (url) {
                uploadedFiles.push(
                    new Media(
                        url,
                        new MediaMetaData(
                            file.height || 0,
                            file.width || 0,
                            file.type || "file",
                            file.name.split('.').pop() || "",
                            file.name || "",
                            file.duration || 0
                        ),
                    )
                )
            }
        }
        setIsLoading(false);
        updateMediaArray(uploadedFiles);
    }
    

    const selectUser = createSelector(
        (state: any) => state.User,
        (user) => user?.user
    );
    const user = useSelector(selectUser);
    useEffect(() => {
    }, [user]);

    const handleDeleteFile = (index: number) => {
        const updatedFiles = media.filter((_: any, i: number) => i !== index);
        updateMediaArray(updatedFiles);
    };

   const updateMediaArray = (arr: Media[]) => {
    setMedia(arr);
    if (arr && arr.length > 0) {
        if (isMultiple) {
            onMediaUpdate(arr);
        } else {
            const media = arr[0];
            const metaData = media.metaData; 
         if (metaData && metaData.fileType === 'application/pdf') {
    const pdfMedia: any = {
        url: media.url, // original PDF link
        fileType: 'application/pdf',
        name: 'PDF Document',
        metaData: {
            ...metaData,
            previewImage: pdfImage  // Add custom thumbnail to metaData
        }
    };
    onMediaUpdate(pdfMedia);
}
 else {
                onMediaUpdate(media);
            }
        }
    } else {
        // onMediaUpdate(pdfImage);  // If arr is empty, bind pdfImage
    }
};


    const handleMediaCenterUpload = (selectedMedia: Media[]) => {
        const existingUrls = new Set(media.map((item) => item.url));
        const filteredSelectedMedia = selectedMedia.filter((item) => !existingUrls.has(item.url));
        if (filteredSelectedMedia.length === 0) {
            toast.error("Please do not repeat select the same pictures.", { autoClose: 1000 });
            return;
        }
        setMedia((prevMedia) => [...prevMedia, ...filteredSelectedMedia]);
        onMediaUpdate([...media, ...filteredSelectedMedia]);
    };

    const [popoverOpen, setPopoverOpen] = useState(false);

    const handleMouseEnter = () => {
        setPopoverOpen(true); // Open popover on hover
    };

    const handleMouseLeave = () => {
        setPopoverOpen(false); // Close popover when mouse leaves
    };

    const handleModalClick = (modalType: any) => {
        if (modalType === 'mediaCenter') {
            setMediaCenterUploadModal(true);
            setUploadModalOpen(false);
        } else if (modalType === 'upload') {
            setUploadModalOpen(true);
            setMediaCenterUploadModal(false);
        }
    };





    return (
        <React.Fragment>
            <ToastContainer />
            <ErrorModal
    show={showModal.isVisible}
    message={errorMessage}
    color={showModal.color}
    onCloseClick={() => setShowModal({ isVisible: false, color: false })}
  />
            <div className={smallUploader ? 'flexMediaBox' : 'mb-4'}>
                <MediaCenterUploadModal
                    key={isMultiple.toString()}
                    show={mediaCenterUploadModal}
                    onAction={handleMediaCenterUpload}
                    onCloseClick={() => setMediaCenterUploadModal(false)}
                    isMultiple={isMultiple}

                />

                {<Dropzone
                    maxFiles={maxFiles}
                    accept={acceptance}
                    disabled={!isMultiple && media.length > 0}
                    onDrop={(acceptedFiles) => {
                        handleAcceptedFiles(acceptedFiles);
                    }}
                >
                    {({ getRootProps, getInputProps }) => (
                        <div className="dropzone dz-clickable" data-testing-id={currentDataId} {...getRootProps()} >
                            <input {...getInputProps()} disabled={!isMultiple && media.length > 0} />
                            {isLoading && <Loader />}
                            {!isLoading &&
                                <div className="dz-message p-2 needsclick h-100 d-flex justify-content-center align-items-center flex-column rounded-2 position-relative" style={{ background: "#ECF5FF" }}>
                                    {threeDotIcon && 
                                    <div className="d-flex justify-content-end al fs-3 w-100 " style={smallUploader ? { zIndex: "999", position: "absolute", top: '-12px', right: "-7px" } : { zIndex: "999" }}>
                                        {currentDataId && !(isMultiple === false && media?.length === 1) &&
                                            user?.storeStatus?.isAddressAdded &&
                                            user?.storeStatus?.isIdBankDetails &&
                                            user?.storeStatus?.isProductAdded &&
                                            user?.storeStatus?.isStoreCreated &&
                                            (
                                                <i
                                                    id={currentDataId}
                                                    data-testing-id='threDotAddProduct_addProduct'
                                                    className="bx bx-dots-horizontal-rounded"
                                                    style={{ color: "#CACACA", cursor: "pointer" }}
                                                    onMouseEnter={(event) => {
                                                        event.stopPropagation();
                                                        handleMouseEnter();
                                                    }}
                                                    onMouseLeave={(event) => {
                                                        event.stopPropagation();
                                                        handleMouseLeave();
                                                    }}
                                                    onClick={(event) => {
                                                        event.stopPropagation();
                                                        setPopoverOpen((prev) => !prev);
                                                    }}
                                                ></i>
                                            )
                                        }

                                        {currentDataId && document.getElementById(currentDataId) && (
                                            <Popover
                                                placement="bottom"
                                                isOpen={popoverOpen}
                                                target={currentDataId}
                                                trigger="manual"
                                                className="p-0"
                                                toggle={() => setPopoverOpen(false)}
                                             >
                                                <PopoverBody
                                                    onMouseEnter={(event) => {
                                                        event.stopPropagation();
                                                        handleMouseEnter();
                                                    }}
                                                    onMouseLeave={(event) => {
                                                        event.stopPropagation();
                                                        handleMouseLeave();
                                                    }}
                                                    className="px-0 py-3"
                                                    onClick={() => setPopoverOpen(false)}
                                                >
                                                    <div className="d-flex flex-column gap-2">
                                                        <div
                                                            className="activeItemsPop w-100 px-2"
                                                            onClick={() => {
                                                                handleModalClick('upload');
                                                                setPopoverOpen(false);
                                                            }}
                                                            data-testing-id='upload_addProduct'
                                                        >
                                                            <p className="text-decoration-none text-dark p-0 m-0 cursor-pointer">
                                                                Upload
                                                            </p>
                                                        </div>
                                                        <div
                                                            className="activeItemsPop w-100 px-2"
                                                            data-testing-id='mediaCenter_addProduct'
                                                            onClick={(event) => {
                                                                event.stopPropagation();
                                                                handleModalClick('mediaCenter');
                                                                setPopoverOpen(false);
                                                            }}
                                                        >
                                                            <p className="text-decoration-none text-dark m-0 p-0 cursor-pointer">
                                                                Media Center
                                                            </p>
                                                        </div>
                                                    </div>
                                                </PopoverBody>
                                            </Popover>
                                        )}
                                    </div>}
                                    <div className='d-flex justify-content-between HeadingHide align-items-center w-100 mb-2'>
                                        <h5 className='fw-bold text-dark m-0 p-0'>{title} {isRequired && <span className="text-danger me-1">*</span>}</h5>
                                        {!isMultiple && media.length > 0 && <i className='bx bx-x text-danger fs-4 fw-bolder cursor-pointer' onClick={() => handleDeleteFile(0)}></i>}
                                    </div>


                                    {isMultiple && <div className=' h-100 w-100'>
                                        <div className='d-flex justify-content-center align-items-center flex-column gap-1 rounded-1 h-100' style={{ background: "#ECF5FF", }}>
                                            <img src={imageUploader} alt="" className='cursor-pointer iconImg' />
                                            <h5 className='mb-1'>Upload or Drop file here.</h5>
                                            <h5>Max file size: 10 MB</h5>
                                        </div>
                                    </div>}



                                    {!isMultiple && (<div className='w-100 h-100' >
                                        <div className=" p-0 rounded-1 position-relative" >
                                            {media.length > 0 && !smallUploader && (<img src={media[0]?.fileType === 'application/pdf' ? pdfImage : media[0].url} alt="" className="cursor-pointer rounded-1 mobileImg" style={{ width: '100%', height: '185px' }} onClick={() => openViewer(media[0]?.url)}/>)}
            {media.length > 0 && smallUploader && (
                <img
                    src={media[0]?.fileType === 'application/pdf' ? pdfImage : media[0].url}
                    alt=""
                    className="cursor-pointer rounded-1 mobileImg"
                    style={{ width: '47px', height: '47px' }}
                    onClick={() => openViewer(media[0]?.url)}
                />
            )}
            {media.length > 0 && smallUploader && (
                <i
                    className="bx bx-x text-danger fs-4 fw-bolder cursor-pointer position-absolute"
                    onClick={() => handleDeleteFile(0)}
                    style={{ right: '-8px', top: '-9px' }}
                ></i>
            )}
            {media.length > 0 && (
                <ImageViewer isOpen={isViewerOpen} imageUrl={currentImage} toggle={closeViewer} />
            )}
        </div>

        {media.length === 0 && (
            <div className="h-100">
                <div
                    className="d-flex mobilrUplad justify-content-center align-items-center flex-column gap-1 rounded-1 w-100 h-100"
                    style={{ background: '#ECF5FF' }}
                >
                    <img src={imageUploader} alt="" className="cursor-pointer iconImg" />
                    <h5 className="mb-1">Upload or Drop file here.</h5>
                    <h5>Max file size: 10 MB</h5>
                </div>
            </div>
        )}
    </div>
)}



                                </div>
                            }

                        </div>
                    )}
                </Dropzone>}
                {media.length > 0 && isMultiple === true && <div className="list-unstyled mediaSmall d-flex justify-content-start gap-4 flex-wrap  mb-0  mt-4" id="file-previews">
                    {media.map((f: any, i: any) => {
                        return (

                            <div className="imageDv dz-message" key={i + "-file"}>
                                {<img
                                    data-dz-thumbnail=""
                                    className="avatar-sm rounded bg-light cursor-pointer"
                                    src={f.url}
                                    onClick={() => openViewer(f.url)}

                                />}
                                <p className='p-0 m-0' style={{ width: "43vh", textOverflow: "ellipsis", whiteSpace: "nowrap", overflow: 'hidden' }}>{f.metaData && f.metaData.name}</p>
                                <ImageViewer isOpen={isViewerOpen} imageUrl={currentImage} toggle={closeViewer} />

                                {
                                    smallUploader && <div className="trashIcon deleteIcon" onClick={() => handleDeleteFile(i)}>
                                        <i className="bx bx-trash bg-red text-white rounded bg-danger p-1 cursor-pointer"></i>
                                    </div>
                                }
                                {/* {!smallUploader && <Col md={10} className='o-hidden'>
                                            <p className="mb-0">
                                                <strong>{f.metaData && f.metaData.name}</strong>
                                            </p>
                                        </Col>} */}
                                {!smallUploader && <Col md={1} className='deleteIcon'>
                                    <div className="w-100 d-flex justify-content-end " onClick={() => handleDeleteFile(i)}>
                                        <i className='bx bx-x text-danger fs-4 fw-bolder cursor-pointer'></i>
                                    </div>
                                </Col>}
                            </div>
                        )
                    })}
                </div>}
            </div>
        </React.Fragment>
    );
};

export default MediaUploader;
